import { setOptions, importLibrary } from "@googlemaps/js-api-loader";
import { GOOGLE_MAPS_LANGUAGE } from "@/features/google-maps/constants/google-maps.constants";

export function useGoogleMapsApi() {
  const isGoogleMapsLoaded = ref(false);
  const mapsLibrary = shallowRef<google.maps.MapsLibrary>();
  const placesLibrary = shallowRef<google.maps.PlacesLibrary>();
  const markerLibrary = shallowRef<google.maps.MarkerLibrary>();

  async function initialize() {
    const {
      public: { GOOGLE_MAPS_API_KEY },
    } = useRuntimeConfig();

    setOptions({ key: GOOGLE_MAPS_API_KEY, v: "weekly", language: GOOGLE_MAPS_LANGUAGE });

    try {
      [mapsLibrary.value, placesLibrary.value, markerLibrary.value] = await Promise.all([
        importLibrary("maps"),
        importLibrary("places"),
        importLibrary("marker"),
      ]);
      isGoogleMapsLoaded.value = true;
    } catch (error) {
      console.error("[useGoogleMapsApi]: failed to init", error);
    }
  }

  onMounted(() => initialize());

  return { mapsLibrary, placesLibrary, markerLibrary, isGoogleMapsLoaded, _initializeServices: initialize };
}
